import { ca } from '@cian/analytics';

export const trackClickOfferFavorite = (id: number | undefined, position: number, action: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Favorite',
    action,
    label: 'offer',
    products: [
      {
        id,
        offerType: 'offer',
        position: position + 1,
      },
    ],
  });
};
